import { testimonials } from '../../../mocks/testimonials';

const starArray = Array.from({ length: 5 });

export default function Testimonials() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">Real Results</span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-4">
            Businesses growing with
            <br />
            <span className="text-orange-500">AdForge AI</span>
          </h2>
          <p className="text-lg text-stone-500 max-w-xl mx-auto">
            Over 3,200 business owners trust AdForge to handle their ad copy. Here\'s what they say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-stone-50 rounded-2xl p-8 border border-stone-100 hover:border-orange-200 transition-all duration-200"
            >
              <div className="flex items-center gap-1 mb-5">
                {starArray.map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <blockquote className="text-stone-700 text-base leading-relaxed mb-6">
                "{t.content}"
              </blockquote>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full overflow-hidden border border-stone-200 shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="font-bold text-stone-900 text-sm">{t.name}</div>
                  <div className="text-stone-500 text-xs">{t.role}</div>
                </div>
                <div className="ml-auto">
                  <span className="text-xs font-medium text-orange-500 bg-orange-50 px-3 py-1 rounded-full border border-orange-100">
                    {t.business}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-stone-50 border border-stone-200 rounded-2xl px-8 py-5">
            <div className="flex -space-x-2">
              {testimonials.slice(0, 3).map((t) => (
                <div key={t.id} className="w-8 h-8 flex items-center justify-center rounded-full overflow-hidden border-2 border-white">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
              ))}
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-500 border-2 border-white text-white text-xs font-bold">+</div>
            </div>
            <p className="text-sm font-medium text-stone-700">
              Joined by <strong className="text-stone-900">3,200+ businesses</strong> — and growing daily
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
